import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["text", "icon", "colSpan"];
import React from 'react';
import Box from '../../Box';
import Text from '../../Text';
import Icon from '../../Icon';
import Td from '../Td';
import Tr from '../Tr';

var Empty = function Empty(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      colSpan = _ref.colSpan,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Tr, rest, /*#__PURE__*/React.createElement(Td, {
    colSpan: colSpan,
    textAlign: "center",
    py: 9
  }, icon && /*#__PURE__*/React.createElement(Box, {
    p: 4,
    mb: text && 7,
    borderColor: "grey30",
    borderStyle: "solid",
    borderWidth: 1,
    display: "inline-block",
    borderRadius: 3
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "grey60",
    "aria-hidden": true,
    as: icon
  })), text && /*#__PURE__*/React.createElement(Text, {
    display: "block",
    color: "grey60",
    size: "Caption1"
  }, text)));
};

export default Empty;